import { ErrorHandler, Injectable, inject } from '@angular/core';

import { NotificationService } from '../services/notification.service';

// Dos errores seguidos no deben apilarse en pantalla: el aviso es uno por ráfaga.
const NOTIFY_THROTTLE_MS = 3000;
const GENERIC_MESSAGE = 'Ocurrió un error inesperado. Intenta de nuevo.';

// Un error que ninguna pantalla atrapó dejaría al usuario con la vista congelada y sin pista. Se
// registra en consola para el equipo y se avisa con un toast, en vez de fallar en silencio.
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly notifications = inject(NotificationService);
  private lastNotifiedAt = 0;

  handleError(error: unknown): void {
    console.error(error);

    // Un error que se repite en cada ciclo de detección taparía la pantalla de toasts.
    const now = Date.now();
    if (now - this.lastNotifiedAt < NOTIFY_THROTTLE_MS) return;
    this.lastNotifiedAt = now;
    this.notifications.error(0, GENERIC_MESSAGE);
  }
}
